import { render, staticRenderFns } from "./ServiceAreasOverview.vue?vue&type=template&id=0ed1ae5d&scoped=true&"
import script from "./ServiceAreasOverview.vue?vue&type=script&lang=js&"
export * from "./ServiceAreasOverview.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreasOverview.vue?vue&type=style&index=0&id=0ed1ae5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed1ae5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed1ae5d')) {
      api.createRecord('0ed1ae5d', component.options)
    } else {
      api.reload('0ed1ae5d', component.options)
    }
    module.hot.accept("./ServiceAreasOverview.vue?vue&type=template&id=0ed1ae5d&scoped=true&", function () {
      api.rerender('0ed1ae5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ServiceAreas/ServiceAreasOverview.vue"
export default component.exports